/**
 * Date            Code               Name                           Description
 * 26/02/2024       y1                Yasmeen                          Added routerlink for accessed 
 */

import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IGlobalRouter, RouterAuditLog } from './global-router.interface';
import { Subject } from 'rxjs/internal/Subject';
import { filter, takeUntil } from 'rxjs/operators';
import { AuditLogService } from '@core/service/audit-log.service';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalRouterService implements OnDestroy, IGlobalRouter {

  readonly ROUTER_AUDIT_LOGS: RouterAuditLog[] = [
    { routerLink: 'ersections/medications', moduleName: 'Medication' },  //y1
    { routerLink: 'ersections/allergies/allergies', moduleName: 'Allergy' },
    { routerLink: 'ersections/history', moduleName: 'History' },
    { routerLink: 'ersections/clinical-trial', moduleName: 'Clinical Trail' },
    { routerLink: 'ersections/dischargeins', moduleName: 'Discharge Instructions' },
    { routerLink: 'ersections/intakeoutput/patient', moduleName: 'In/Out' },
    { routerLink: 'Locations/Locations', moduleName: 'Location' },
    { routerLink: 'ersections/mar/mar', moduleName: 'MAR' },
    { routerLink: 'ersections/problems', moduleName: 'Problem' },
    { routerLink: 'ersections/procedures', moduleName: 'Procedure' },
    { routerLink: 'ersections/ros', moduleName: 'ROS' },
    { routerLink: 'ersections/phe', moduleName: 'PHE' },
    { routerLink: 'Scheduler/viewschedule', moduleName: 'Scheduling' },
    { routerLink: 'Settings/nursingstation', moduleName: 'Setting' },
    { routerLink: 'ersections/summary', moduleName: 'Summary' },
    { routerLink: 'ersections/vitals/vitals', moduleName: 'VitalSigns' },
    { routerLink: 'Patient/NewPatientVisit', moduleName: 'Visit' },
    { routerLink: 'Customization/add-template', moduleName: 'Template' },
    { routerLink: 'ersections/signout', moduleName: 'Signout' },
    { routerLink: 'ersections/actions', moduleName: 'NurseAction' },
    { routerLink: 'ersections/dispositionDetails', moduleName: 'Disposition' },
    { routerLink: 'ersections/checkout', moduleName: 'Checkout' },
    { routerLink: 'ersections/laborders/orders', moduleName: 'Lab Order' },
    { routerLink: 'ersections/labresults/results', moduleName: 'Lab Results' },
    // { routerLink: 'admin/patients/amendment', moduleName: 'Amendment' },
    // { routerLink: 'ersections/radiology', moduleName: 'Radiology Order' },  //y1
    { routerLink: 'ersections/radiology', moduleName: 'Radiology Results' },
    { routerLink:'ersections/ordersets',moduleName:'ADT Orders'}, 
    { routerLink:'ersections/ordersets',moduleName:'Diet Orders'},
    { routerLink:'ersections/ordersets',moduleName:'All Orders'},
    {routerLink:'Customization/menu-role',moduleName:'User Previleges'}, //y1
    {routerLink:'ersections/careplan',moduleName:'CarePlan'}
  ];
  currentModule: string | null = null;
  previousModule: string | null = null;
  previousActivityId=0;

  constructor(
    private _router: Router,
    private _auditLogService: AuditLogService
  ) {
    this.onRouterChange(this.ROUTER_AUDIT_LOGS);
  }

  moduleName='';
  //#region Other Methods ------------------------------------------------------------------------------------
  /**
   * Handles router change events and logs the activity.
   * 
   * This method subscribes to router events and listens for `NavigationEnd` events.
   * When a navigation ends, it checks if the new URL matches any of the provided
   * `RouterAuditLog` entries. If a match is found, it logs the access activity.
   * 
   * @param {RouterAuditLog[]} ROUTER_AUDIT_LOGS - An array of router audit logs to check against.
   * 
   * @remarks
   * - The method uses RxJS operators `filter` and `takeUntil` to manage the subscription.
   * - It logs the activity by calling the `saveAuditLog` method with appropriate parameters.
   * 
   * @example
   * ```typescript
   * const auditLogs: RouterAuditLog[] = [
   *   { routerLink: '/home', moduleName: 'Home', email: 'user@example.com', encryptType: 'AES' },
   *   { routerLink: '/about', moduleName: 'About', email: 'user@example.com', encryptType: 'AES' }
   * ];
   * 
   * this.onRouterChange(auditLogs);
   * ```
   */
  onRouterChange(ROUTER_AUDIT_LOGS: RouterAuditLog[]): void {
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.onDestroy$)
    ).subscribe((event: NavigationEnd) => {
      // console.log('Route changed:', event);
      
      let routerAudioLog: RouterAuditLog = ROUTER_AUDIT_LOGS.find(obj => event.urlAfterRedirects.includes(obj.routerLink));
      this.currentModule = routerAudioLog?.moduleName;
      if (routerAudioLog) {
        let activityId: number = 3; // activity id for `Accessed`.
        let moduleName: string = routerAudioLog.moduleName;
        this.moduleName=moduleName;
        let description: string = 'Accessed ' + moduleName;
        let email:string=routerAudioLog.email;
        let encryptType:string=routerAudioLog.encryptType;
        // let ipAddress:string=routerAudioLog.ipAddress
        this.saveAuditLog(activityId, description, moduleName,email,encryptType);
      }

    });
  }
  //#endregion Other Methods ---------------------------------------------------------------------------------
  
  activityId: number;
  //#region Service Methods ----------------------------------------------------------------------------------
  saveAuditLog(activityId: number, description: string, moduleName: string,email:string,encryptType:string): void {
    this.saveAuditLogObs(activityId, description, moduleName,email,encryptType).pipe(takeUntil(this.onDestroy$)).subscribe((res) => {
      // console.log(res);
      this.activityId=+res?.body?.value;
      //  console.log('Save activityId',this.activityId)

       this.updateAuditEndDateLog(moduleName,this.activityId)

    }, (error) => {
      // console.error('Error saving audit log:', error);

    });
  }
  updateAuditEndDateLog(moduleName:string,activityId: number){
    if (this.currentModule && this.previousModule && this.previousModule !== this.currentModule) {
      
       // const activityId: number = 0;
      //  console.log('Activity ID::',this.activityId,' ----- ** Previous Activity Id:',this.previousActivityId)
        this._auditLogService.updateAuditEndDate(this.previousActivityId).subscribe();
    
      
    }
    this.previousModule=moduleName;
    this.previousActivityId=activityId;
  }
  //#endregion Service Methods -------------------------------------------------------------------------------
  
  //#region Observables Methods ------------------------------------------------------------------------------
  saveAuditLogObs(activityId: number, description: string, moduleName: string,email:string,encryptType:string): Observable<HttpResponse<any>> {
    return this._auditLogService.saveAudit(activityId, description, moduleName,email,encryptType);
  }
  //#endregion Observables Methods ---------------------------------------------------------------------------
  
  //#region Re-Usable Methods --------------------------------------------------------------------------------
  //#endregion Re-Usable Methods -----------------------------------------------------------------------------

  onDestroy$: Subject<boolean> = new Subject<boolean>();
  ngOnDestroy(): void {
    // console.log('Killed section:****',this.moduleName)
    this.onDestroy$.next(false);
  }
}
